import React, { useState, useEffect } from 'react';
import Image from 'components/AppImage';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const FEATURED = [
{
  id: 1,
  title: "Glow & Thrive Skincare",
  subtitle: "Founder: Dr. Amara Johnson",
  tagline: "Science-backed skincare for melanin-rich skin",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_135da61e2-1772158643240.png",
  imageAlt: "Elegant skincare product bottles with gold accents arranged on white marble surface with green leaves",
  badge: "WIN Pick of the Month",
  cta: "Shop Now",
  discount: "15% off with code WIN15"
},
{
  id: 2,
  title: "TechHer Solutions",
  subtitle: "Founder: Priya Nair",
  tagline: "Smart home devices designed by women, for everyone",
  image: "https://images.unsplash.com/photo-1640826808046-6d4d4faa30c8",
  imageAlt: "Modern smart home device with sleek design displayed on minimalist desk with soft ambient lighting",
  badge: "New Arrival",
  cta: "Explore Products",
  discount: "Free shipping on orders over $75"
},
{
  id: 3,
  title: "Harvest & Bloom Foods",
  subtitle: "Founder: Maria Santos",
  tagline: "Organic, small-batch artisan foods from our family to yours",
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_186332abc-1770194976644.png",
  imageAlt: "Colorful array of organic artisan food products in glass jars arranged on rustic wooden table",
  badge: "Community Favorite",
  cta: "Taste the Difference",
  discount: "Bundle & save up to 20%"
}];


export default function FeaturedBanner({ onShopNow }) {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setActive((p) => (p + 1) % FEATURED?.length), 5000);
    return () => clearInterval(timer);
  }, []);

  const item = FEATURED?.[active];

  return (
    <div className="relative w-full rounded-2xl overflow-hidden h-48 md:h-64 lg:h-72"
    style={{ border: '2px solid var(--color-accent)' }}>
      <Image src={item?.image} alt={item?.imageAlt} className="w-full h-full object-cover" />
      <div className="absolute inset-0" style={{ background: 'linear-gradient(to right, rgba(0,48,87,0.92) 50%, rgba(0,48,87,0.4))' }} />
      <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-10">
        <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full font-caption text-xs font-semibold mb-3 w-fit"
        style={{ background: 'var(--color-accent)', color: 'var(--color-accent-foreground)' }}>
          <Icon name="Crown" size={11} color="var(--color-accent-foreground)" />
          {item?.badge}
        </span>
        <h2 className="font-heading font-bold text-xl md:text-3xl text-white mb-1">{item?.title}</h2>
        <p className="font-caption text-sm md:text-base mb-1" style={{ color: 'rgba(255,255,255,0.8)' }}>{item?.subtitle}</p>
        <p className="font-body text-sm hidden md:block mb-3" style={{ color: 'rgba(255,255,255,0.7)' }}>{item?.tagline}</p>
        <div className="flex items-center gap-3">
          <Button variant="default" size="sm" onClick={() => onShopNow(item)}>{item?.cta}</Button>
          <span className="font-caption text-xs" style={{ color: 'var(--color-accent)' }}>{item?.discount}</span>
        </div>
      </div>
      {/* Dots */}
      <div className="absolute bottom-3 right-4 flex gap-1.5">
        {FEATURED?.map((_, i) =>
        <button key={i} onClick={() => setActive(i)}
        className="rounded-full transition-all duration-300"
        style={{ width: i === active ? '20px' : '8px', height: '8px', background: i === active ? 'var(--color-accent)' : 'rgba(255,255,255,0.5)' }}
        aria-label={`Go to slide ${i + 1}`} />
        )}
      </div>
    </div>);

}